import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import MyProvidersList from '@/components/providers/MyProvidersList';

const MyProviders = () => {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold">My Providers</h1>
          <p className="text-gray-600 mt-1">Manage the educational providers you've created</p>
        </div>
        <Button onClick={() => navigate('/providers/create')} className="flex items-center">
          <Plus className="mr-2 h-4 w-4" />
          Create Provider
        </Button>
      </div>
      
      <MyProvidersList />
    </div>
  );
};

export default MyProviders;
